export default __webpack_public_path__ + "logo-amazonpay.1fae0f1e.1f78a838.png";